import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { ClientsComponent } from '../clients/clients.component';
import { Customer, CustomerService } from 'src/api/api.services';

@Component({
  selector: 'app-client-form',
  templateUrl: './client-form.component.html',
  styleUrls: ['./client-form.component.css']
})
export class ClientFormComponent implements OnInit {

  public form: FormGroup = this.formBuilder.group({
    companyName: [null, Validators.required],
    firstName: [null],
    lastName: [null],
    companyIdentificationNumber: [null],
    address: [null],
    contact: [null],
  });

  constructor(
    private customerService: CustomerService,
    public dialogRef: MatDialogRef<ClientsComponent>,
    private formBuilder: FormBuilder,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
  }

  openSnackBar(message: string, className: string) {
    this._snackBar.open(message, null, {
      duration: 2000,
      panelClass: [className]
    });
  }

  submit() {
    var isCorrect: boolean = false;
    var iceNumber = this.form.value.companyIdentificationNumber;
    var companyName = this.form.value.companyName;
    var firstName = this.form.value.firstName;
    var lastName = this.form.value.lastName;
    var address = this.form.value.address;
    var contactF = this.form.value.contact;
    if (companyName != null) {
      companyName = companyName.toUpperCase();
    }
    if (iceNumber != null) {
      if (iceNumber.length == 0) {
        iceNumber = null;
      }else{
        iceNumber = iceNumber.toUpperCase();
      }
    }
    if (firstName != null) {
      if (firstName.length == 0) {
        firstName = null;
      } else {
        firstName = firstName.toUpperCase();
      }
    }
    if (lastName != null) {
      if (lastName.length == 0) {
        lastName = null;
      } else {
        lastName = lastName.toUpperCase();
      }
    }
    if (address != null) {
      if (address.length == 0) {
        address = null;
      } else {
        address = address.toUpperCase();
      }
    }
    if (contactF != null) {
      if (contactF.length == 0) {
        contactF = null;
      }
    }
    var customer: Customer = new Customer({
      companyName: companyName,
      firstName: firstName,
      lastName: lastName,
      companyIdentificationNumber: iceNumber,
      address: address,
      contact: contactF
    });

    this.customerService.customerPost(customer).subscribe(res => {
      isCorrect = true;
      this.openSnackBar("Client ajouté", "snackbarCorrect")
      this.dialogRef.close(isCorrect);
    }, err => this.openSnackBar("Erreur", "snackbarError"));
  }
}
